<template>
  <b-modal
    id="edit-floor-modal"
    title="Floor Edit Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
  >
    <template #modal-title>
      <h2 class="m-0">Floor Edit</h2>
    </template>
    <b-form @submit.prevent enctype="multipart/form-data">
      <b-form-group label-for="floor_no">
        <template #label>
          Floor No <span class="text-danger">*</span>
        </template>
        <b-input
          id="floor_no"
          v-model="floor_no"
          placeholder="Floor No"
          v-restrict="regex"
          required
        ></b-input>
      </b-form-group>

      <b-form-group class="mt-2 text-right">
        <b-button
          type="submit"
          variant="primary"
          pill
          class="mr-1"
          @click="submit"
        >
          Update Floor
        </b-button>
        <b-button
          type="reset"
          variant="outline-secondary"
          @click="reset"
          pill
        >
          Reset
        </b-button>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: { floor : Object },
  mixins: [util],
  data() {
    return {
      required,
      floor_no: "",
      regex: /^[a-zA-Z ]*$/,
    };
  },
  methods: {
    ...mapActions({
      updateFloor: "appData/updateFloor",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("floor_no", this.floor_no);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateFloor({
          payload: formData,
          pk: this.floor.id
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Floor Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-floor-modal");
          });          
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    onModalShow(){
      this.floor_no = this.floor.floor_no;
      this.manager_name = this.floor.manager_name;
      this.manager_phone = this.floor.manager_phone;
      this.manager_email = this.floor.manager_email;
    },
       
    reset() {
      this.floor_no = "";
      this.manager_email = "";
      this.manager_name = null;
      this.manager_phone = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),    
  },  
 
};
</script>

<style></style>
